// Heckin "Make it your dog": closed-state bootstrap (sticker, card pill, open button, #customize, Design guard).
// hg-customize.js/.css load only on open, while a preview is in progress or with ?design= in the URL.
const d = document;
const root = d.querySelector('[data-hg-cz]');
const still = matchMedia('(prefers-reduced-motion: reduce)');
let mod;

const beacon = (api, type, product) => {
  if (!api) return;
  try {
    navigator.sendBeacon(`${api}/api/v1/events`, new Blob([JSON.stringify({ type, product })], { type: 'text/plain' }));
  } catch {}
};

const load = () => {
  if (!root) return Promise.reject();
  if (!mod) {
    const css = new Promise((done) => {
      const link = Object.assign(d.createElement('link'), { rel: 'stylesheet', href: root.dataset.css });
      link.onload = link.onerror = done;
      d.head.append(link);
    });
    mod = Promise.all([import(root.dataset.src), css]).then(([m]) => m);
  }
  return mod;
};

const open = (trigger) => load().then((m) => m.open(root, trigger), () => {});

if (root && !root.dataset.boot) {
  root.dataset.boot = '1';
  d.addEventListener('click', (e) => {
    const b = e.target instanceof Element && e.target.closest('[data-hg-cz-open]');
    if (b) open(b);
  });
  root.querySelector('[data-hg-cz-open]')?.addEventListener('pointerenter', load, { once: true });
  // ?design=CODE (a reopened design, see hg-customize.js) loads it like the sessionStorage restore.
  if (location.hash === '#customize') open();
  else if (new URLSearchParams(location.search).has('design') || sessionStorage.getItem(`hgcz:${root.dataset.product}`)) {
    load().then((m) => m.restore(root), () => {});
  }
}

// ?variant=<a Your dog variant>: switch to Original through Horizon's own picker flow.
const fix = d.querySelector('[data-hg-design-mismatch] input:checked');
if (fix) customElements.whenDefined('variant-picker').then(() => fix.dispatchEvent(new Event('change', { bubbles: true })));

for (const s of d.querySelectorAll('[data-hg-cz-sticker]')) {
  if (s.dataset.boot) continue;
  s.dataset.boot = '1';
  const card = s.dataset.hgCzSticker === 'card';
  const api = (root?.dataset.api || s.dataset.api || '').replace(/\/$/, '');
  const kind = card ? 'card_sticker' : 'sticker';
  let seen = false;
  let shown = false;
  let wiggles = 0;
  let last = 0;
  const wiggle = () => {
    if (card || still.matches || !shown || wiggles >= 3 || Date.now() - last < 8000) return;
    wiggles += 1;
    last = Date.now();
    s.classList.remove('is-wiggle');
    void s.offsetWidth;
    s.classList.add('is-wiggle');
  };
  s.addEventListener('animationend', () => s.classList.remove('is-wiggle'));
  new IntersectionObserver(
    ([e]) => {
      shown = e.isIntersecting;
      if (!shown) return;
      if (!seen) {
        seen = true;
        beacon(api, `${kind}_view`, s.dataset.product);
        setTimeout(wiggle, 700);
      }
    },
    { threshold: 0.5 }
  ).observe(s);
  const timer = card ? 0 : setInterval(() => (wiggles < 3 ? wiggle() : clearInterval(timer)), 8100);
  s.addEventListener('click', () => {
    beacon(api, `${kind}_click`, s.dataset.product);
    if (!card) open(s);
  });
}

// Card "Customizable" pill: a plain link to <product>#customize; only the click is counted here.
for (const p of d.querySelectorAll('[data-hg-cz-pill]')) {
  if (p.dataset.boot) continue;
  p.dataset.boot = '1';
  p.addEventListener('click', () => beacon((p.dataset.api || '').replace(/\/$/, ''), 'card_pill_click', p.dataset.product));
}
